import React from 'react'
import Content from '../../_utilities/data/sections/counter.json'
import Link from 'next/link'
import Image from 'next/image'
import Counter from '../Hero/Counter'

interface CounterItem {
  [x: string]: string;
  image: string;
  name: string;
  text: string;
}

const CounterSection: React.FC = () => {
  const awardsItems: CounterItem[] = []

  Content.items.forEach((item, index) => {
    let itemClass = 'mil-awards-box mil-gradient-bg '
    if ((index + 1) % 2 === 0) {
      itemClass += 'mil-box-2'
    }
    if (index > Content.items.length - 3) {
      itemClass += ' mil-pb-60-adapt '
    }
    let newobj = Object.assign({}, item, { boxClass: itemClass });
    awardsItems.push(newobj as CounterItem);
  });

  return (
    <section className="mil-awards mt-2">
      <div className="row m-0">
        <div className="col-xl-6 p-0 mil-relative">
          <Image
            src={Content.bg_image}
            height={700}
            width={700}
            className="mil-background-image"
            style={{ objectPosition: 'center' }}
            data-swiper-parallax-scale="1.1"
            alt="image"
          />
          <div className="mil-overlay" />
          <div className="mil-fake-container">
            <h2 className="mil-light mil-mb-30 mil-h2">
              {Content.title.first}{' '}
               <span className="mil-accent">{Content.title.second}</span>
            </h2>
            <p className=" mil-mb-30 mil-light-soft mil-font-2" style={{ textAlign: 'justify' }}>
              {Content.description}
            </p>
            <Link href={Content.button.link} className="mil-link">
              <span className="mil-light">{Content.button.label}</span>
              <i className="fas fa-arrow-right" />
            </Link>
          </div>
        </div>
        <div className="col-xl-6 p-0 mil-cont">
          <div className="row m-0">
            {awardsItems.map((item, key) => (
              <div key={key} className="col-6 p-0 col-md-6 col-xl-6 p-0 award-stat">
                <div className={item.boxClass}>
                  <div className="mil-icon-box mil-center">
                    <div className="mil-icon-frame-md mil-mb-10">
                      <Image
                      src={item.image}
                      height={80}
                      width={80}
                      alt={item.text} 
                      
                      />
                    </div>
                    <div className="mil-h1 mil-accent">
                      <Counter end={parseFloat(item.name)} /> {item?.name === "94%" ? "%" : "+"}
                    </div>
                    <p
                      className="mil-text-sm mil-light-soft"
                      style={{ fontSize: "1.1rem" }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
